import { useState, useEffect, useContext } from "react";
import { Census_func } from "../../../api/devices/census/census_func";
import { Groups_func } from "../../../api/devices/groups/groups_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Modal, Stack, StackItem, TooltipHost } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, Popover, PopoverTrigger, PopoverSurface, Toast, ToastTitle, Toaster, useId, ToastPosition, useToastController, ToastBody, ToastTrigger, Link, ToastFooter, Field, ProgressBar, MessageBar, MessageBarBody, MessageBarTitle, Input, Label, Card, ButtonProps, Image, ToggleButton, Tooltip, Body1Stronger } from "@fluentui/react-components";
import { PhoneLaptop20Regular, BookNumber20Regular, BookTemplate20Regular, Filter20Filled, FilterDismiss20Filled, Desktop20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize16Regular, AddSquare20Regular, SlideEraser20Regular, Warning20Filled, Dismiss16Regular, ArrowMaximize20Regular, DismissSquare24Filled, Info20Filled } from "@fluentui/react-icons";
import { AddSquare24Regular, Delete24Regular, } from "@fluentui/react-icons";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { CheckBox } from "../../../components/checkbox/checkbox_component";
import React from "react";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { GlobalContext } from "../../../hooks/globalContext";
import { ToastComponent } from "../../../components/toast/toast.component";
import { fullscreenIcon, lightTheme, messageTheme, primaryIcon, exitIcon, overflowDivider, deleteIcon, secondaryIcon, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import { TroubleshooterDevice_fun } from "../../../api/troubleshoot/troubleshooterDevice_fun";
import { shouldLoadRoute } from "../../../Authentication/RouteProtection";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { App_Monitored_Func } from "../../../api/app/app_monitored_func";
import { skip } from "node:test";


export const DeviceClassificationScores = () => {
  const contextValue: any = useContext(GlobalContext);

  const [isIconEnabled, setIconEnabled] = useState(false);
  const handleIconActive: any = (data: any) => {
    setIconEnabled(data.target.checked);
  }

  const [isModalIconEnabled, setModalIconEnabled] = useState(false);
  const handleModalIconActive: any = (data: any) => {
    setModalIconEnabled(data.target.checked);
  }

  const [messagebar, setmessagebar] = useState(false);
  var tenantName = contextValue.tenantName;
  const navigate = useNavigate();
  const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [isRefresh, setIsRefresh]: any = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [isfilter, setIsFilter] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [scoresCpuRequired, setScoreCpuRequired] = useState(false);
  const [scoresMemRequired, setScoreMemRequired] = useState(false);
  const [scoresNetRequired, setScoreNetRequired] = useState(false);
  const [deviceName, setDeviceName] = useState('');
  const [deviceList, setDeviceList]: any = useState(null);
  const [errorToast, setErrorToast]: any = useState(false);
  //  const [permissions, setPermissions] = useState(['']);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const { permissions } = usePermissionStore();
  const [loading, setLoading] = useState(true);
  const [appData, setAppData]: any = useState([]);
  const [formDataBasic, setFormDataBasic]: any = useState({
    Category: '',
    Subcategory: '',
    ApplicationName: '',

    ApplicationType: '',
    UrlPatterns: [{
      // urlpattern: '',
    }],
    ApplicationBinaries: '',
    cpuUtilisation: [{
      cpuFrom: '',
      cpuTo: '',
      cpuScore: '',
      cpuRank: '',
    }],
    memUtilisation: [{
      memFrom: '',
      memTo: '',
      memScore: '',
      memRank: '',
    }],
    netUtilisation: [{
      netFrom: '',
      netTo: '',
      netScore: '',
      netRank: '',
    }],
  });

  const inputId = useId("input");
  const [toastMessage, setToastMessage]: any = useState(false);

  const handle = useFullScreenHandle();
  //   const handleOutsideButton = () => {
  //     buttonref?.current?.click();
  //  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
  }
  const handleInput = (value: any, processName: String, compName: any, index: number) => {
    if (processName == 'cpuUtilisation' && value != '') {
      setScoreCpuRequired(true);
    }
    else {
      setScoreCpuRequired(false)
    }
    if (processName == 'memUtilisation' && value != '') {
      setScoreMemRequired(true);
    }
    else {
      setScoreMemRequired(false)
    }
    if (processName == 'netUtilisation' && value != '') {
      setScoreNetRequired(true);
    }
    else {
      setScoreNetRequired(false)
    }

    setFormDataBasic({ ...formDataBasic, [`${processName}`]: [...formDataBasic[`${processName}`].slice(0, index), { ...formDataBasic[`${processName}`][index], [`${compName}`]: value }, ...formDataBasic[`${processName}`].slice(index + 1)] });
  }
  const handleAddClone = (index: any, processName: String) => {

    if (processName == 'cpuUtilisation' && formDataBasic[`${processName}`].length <= 3) {
      setFormDataBasic({ ...formDataBasic, [`${processName}`]: [...formDataBasic[`${processName}`], { cpuFrom: '', cpuTo: '', cpuScore: '', cpuRank: '' }] });
    } else if (processName == 'memUtilisation' && formDataBasic[`${processName}`].length <= 3) {
      setFormDataBasic({ ...formDataBasic, [`${processName}`]: [...formDataBasic[`${processName}`], { memFrom: '', memTo: '', memScore: '', memRank: '' }] });
    } else if (processName == 'netUtilisation' && formDataBasic[`${processName}`].length <= 3) {
      setFormDataBasic({ ...formDataBasic, [`${processName}`]: [...formDataBasic[`${processName}`], { netFrom: '', netTo: '', netScore: '', netRank: '' }] });
    } else if (processName == 'UrlPatterns' && formDataBasic[`${processName}`].length <= 3) {
      setFormDataBasic({ ...formDataBasic, [`${processName}`]: [...formDataBasic[`${processName}`], {}] });
    }
  };
  const handleRemoveClone = (id: any, processName: String) => {
    var tempArr = formDataBasic[`${processName}`].filter((val: any, i: any) => i !== id);

    setFormDataBasic({ ...formDataBasic, [`${processName}`]: tempArr });
  };

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    if (name === 'filter') {
      setDropDownValue2(enteredValue);
    }
  }
  const handleFilterArray = (): any => {
    const value1 = dropDownValue1
    const value2 = dropDownValue2;
    if (value1 !== undefined && value1 !== "" && value2 !== undefined && value2 !== "") {
      const result = value1 + " : " + value2;
      setFilterArray([...filterArray, result]);
      setIsFilter(true);
    }
  }

  const handleCloseFilter = (index: any): any => {
    console.log("clicked");
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
  }

  useEffect(() => {
    if (filterArray.length > 0)
      setResetDisabled(false)

  }, [filterArray])

  var menuItems: any = [];

  const toasterId = useId();
  const { dispatchToast } = useToastController(toasterId);
  const [position, setPosition] = React.useState<ToastPosition>("top-end");

  const deleteToast = () =>
    dispatchToast(
      <Toast>
        <ToastTitle
          action={
            <ToastTrigger>
              <Link > <Dismiss16Regular /> </Link>
            </ToastTrigger>}
        > Sucess </ToastTitle>
        <ToastBody> Device Classification Chem Factory Worker - 001 is deleted succesfully </ToastBody>
      </Toast>,
      { position, intent: "success" }
    );

  const configModal = () =>
    <Modal>HEY</Modal>

  menuItems.push
    (
      <MenuItem onClick={() => navigate("/manage/devices/device_classification/devices")}
        icon={
          <Stack horizontal tokens={{ childrenGap: 40 }}>
            <StackItem><Text></Text></StackItem>
            <StackItem> <PhoneLaptop20Regular {...primaryIcon} /> </StackItem>
          </Stack>}>
        <Stack tokens={{ childrenGap: 30 }} horizontal>
          <StackItem><Text></Text></StackItem>
          <StackItem> <Caption1> Devices </Caption1> </StackItem>
          <StackItem> <Stack tokens={{ childrenGap: 80 }} horizontal> <StackItem><Text></Text></StackItem> <StackItem><Text></Text></StackItem> </Stack> </StackItem>
          {/* SPACING IN INLINE SIDEBAR */}
        </Stack>
      </MenuItem>
    );

  menuItems.push
    (
      <FluentProvider theme={lightTheme}>
        <MenuItem onClick={() => navigate("/manage/devices/device_classification/scores")}
          icon={
            <Stack horizontal tokens={{ childrenGap: 40 }}>
              <StackItem><Text></Text></StackItem>
              <StackItem> <BookNumber20Regular {...primaryIcon} /> </StackItem>
            </Stack>}>
          <Stack tokens={{ childrenGap: 30 }} horizontal>
            <StackItem><Text></Text></StackItem>
            <StackItem> <Caption1> Scores </Caption1> </StackItem>
          </Stack>
        </MenuItem>
      </FluentProvider>
    );

  // menuItems.push
  //   (
  //     <MenuItem onClick={() => navigate("/manage/devices/device_classification/audit_log")}
  //       icon={
  //         <Stack horizontal tokens={{ childrenGap: 40 }}>
  //           <StackItem><Text></Text></StackItem>
  //           <StackItem> <BookTemplate20Regular {...primaryIcon} /> </StackItem>
  //         </Stack>}>
  //       <Stack tokens={{ childrenGap: 30 }} horizontal>
  //         <StackItem><Text></Text></StackItem>
  //         <StackItem> <Caption1> Audit Log </Caption1> </StackItem>
  //       </Stack>
  //     </MenuItem>
  //   );
  //inline side menu content code ends here

  //data table column name code starts here
  var columns = [
    { key: "classification_name", label: <Body1Strong>&nbsp; Category </Body1Strong> },
    { key: "created_by", label: <Body1Strong>&nbsp; Subcategory </Body1Strong> },
    { key: "created_on", label: <Body1Strong>&nbsp; Name </Body1Strong> },
    { key: "last_modifed", label: <Body1Strong>&nbsp; URL Patterns </Body1Strong> },
    { key: "linked_devices", label: <Body1Strong>&nbsp; Desktop Binaries </Body1Strong> },
  ];
  //data table column name code ends here

  //data table for filter 
  var columns1 = [
    { key: "", label: <Caption1> Application verison </Caption1> },
    { key: "category", label: <Caption1> Category </Caption1> },
    { key: "", label: <Caption1> Installed On </Caption1> },
    { key: "created_by", label: <Caption1> Subcategory </Caption1> },
    { key: "name", label: <Caption1> Name </Caption1> },
    { key: "last_modifed", label: <Caption1> URL </Caption1> },
    { key: "desktop_pattern", label: <Caption1> Binaries </Caption1> },
    { key: "last_modifed", label: <Caption1> Scores </Caption1> },


  ];

  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>
        {/* <Stack tokens={{childrenGap:10}} horizontal> */}
        <StackItem>
          {permissions.includes("all") || permissions.includes("deviceClassification_Fullaccess") ? (
            <Button shape="circular" appearance="subtle" size="small" onClick={() => { setOverlayOpen(true) }}>
              <Stack tokens={{ childrenGap: 6 }}>
                {/* <StackItem><Text></Text></StackItem> */}
                <StackItem>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem> <AddSquare20Regular {...primaryIcon} /> </StackItem>
                    <StackItem> <Caption1>View Score</Caption1> </StackItem>
                  </Stack>
                </StackItem>
              </Stack>
            </Button>
          ) :
            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
              <Button shape="circular" appearance="subtle" size="small" disabled>
                <Stack tokens={{ childrenGap: 6 }}>
                  {/* <StackItem><Text></Text></StackItem> */}
                  <StackItem>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                      <StackItem> <Caption1>View Score</Caption1> </StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </Button>
            </Tooltip>}
        </StackItem>

        {/* <StackItem>

            <Button shape="circular" appearance="subtle" size="small" onClick={() => {setOverlayOpen(true)}}>
                <Stack tokens={{childrenGap:6}}>
                    <StackItem><Text></Text></StackItem>
                    <StackItem>
                    <Stack tokens={{childrenGap:5}} horizontal>
                        <StackItem> <AddSquare20Regular {...primaryIcon}/> </StackItem>
                        <StackItem> <Caption1>Modify Scores </Caption1> </StackItem>
                    </Stack>
                    </StackItem>
                </Stack>
            </Button>
          </StackItem> */}

        <StackItem> <Divider vertical /> </StackItem>

        {/* <Stack tokens={{childrenGap:6}}> */}
        {/* <StackItem><Text></Text></StackItem> */}
        <StackItem>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setIsRefresh(true); }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>

          {permissions.includes("all") || permissions.includes("deviceClassification_Fullaccess") || permissions.includes("deviceClassification_ReadandExport") ? (
            <>
              <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_device_scoreslist.csv`}>
              </CSVLink>
              <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => setExportBtnClicked(true)}>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                  <StackItem> <Caption1> Export </Caption1> </StackItem>
                </Stack>
              </Button>
            </>
          ) :
            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
              <Button shape="circular" appearance="subtle" size="small" disabled>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                  <StackItem> <Caption1> Export </Caption1> </StackItem>
                </Stack>
              </Button>
            </Tooltip>
          }

          {/* <Button shape="circular" appearance="subtle" size="small">
                <Stack tokens={{childrenGap:5}} horizontal>
                  <StackItem> <Settings20Regular {...primaryIcon}/> </StackItem>
                  <StackItem> <Caption1> Manage View </Caption1> </StackItem>
                </Stack>
              </Button> */}
        </StackItem>
        {/* </Stack> */}
        {/* </Stack> */}
        <StackItem grow shrink>
          <Stack horizontalAlign="end">
            <StackItem grow shrink>
              <FullScreenButton handle={handle} />
            </StackItem>
          </Stack>
        </StackItem>

      </>
    ,
  };
  // overflow set contents code ends here

  var tempTableData: any = [];
  var menuLists: any = [];
  var tempExportData: any = [];
  useEffect(() => {
    var tempExportData: any = [];
    console.log("exportDetails=", exportDetails);

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      tempExportData.push({
        'Classification Name': val.host,
        'Created By': val.site,
        'Created_on': val.created_on,
        'Version': val.osversion,
        'Nanoheal version': val.clientversion,
        'Last Event': new Date(val.born * 1000).toLocaleString(),
        'Configuration Group': new Date(val.last * 1000).toLocaleString()
      });
    });

    setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  useEffect(() => {
    // data table values append code starts here
    console.log("final_data=", final_data);

    final_data !== undefined && final_data !== null ?
      final_data.map((val: any, i: any) => {
        const operatingSystem = val.os;
        const Operating_System = operatingSystem?.substring(0, 19) + "\n" + operatingSystem?.substring(17);

        tempTableData.push({
          id: val.host,
          checkbox: "hide",
          classification_name: { label: <Caption1> {val.host} </Caption1>, icon: "", id: `${i}` },
          created_by: { label: <Caption1> {val.site} </Caption1>, icon: "", status: "" },
          created_on: { label: <Caption1> {Operating_System !== "undefined\nundefined" ? Operating_System : "-"} </Caption1>, icon: "" },
          osversion: { label: <Caption1> {val.clientversion} </Caption1>, icon: "" },
          linked_devices: { label: <Caption1> {val.clientversion} </Caption1>, icon: "" },
          last_modifed: { label: <Caption1> {val.born} </Caption1>, icon: "" },
          config_group: { label: <Caption1> {val.last} </Caption1>, icon: "" },
        });
      })
      : (tempTableData = []);

    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);

    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);
    }, 500);
  }, [final_data, permissions]);
  // data table values append code ends here

  //overlay code starts here
  var overLayData: any = {
    size: "large",
    isTabs: true,
    headerTitle:
      (
        <>
          <FluentProvider theme={dashboardTheme}>
            <Title3> Score Assigned to this classification </Title3>
          </FluentProvider>
        </>
      ),

    tabItems: {

      Scores:
        <form id="myFormAppmonitored" onSubmit={handleSubmit}> <>
          <Stack tokens={{ childrenGap: 15 }}>
            {appData.filter((i: any) => i.status && i.status.includes(localStorage.getItem('classificationName')))
              .length === 0 ? (
              <StackItem><Body1Strong>No score assigned to this classification</Body1Strong></StackItem>
            ) : (
              appData.filter((i: any) => i.status && i.status.includes(localStorage.getItem('classificationName')))
                .map((i: any) => {
                  const scores = JSON.parse(i.Scores).range;
                  return scores.map((score: any, index: number) => (
                    <>
                      {index == 0 &&
                        <StackItem><Body1Stronger>{`Application name: ${i.MetricDesc}`}</Body1Stronger></StackItem>}
                      <StackItem key={`${i.id}-${index}`}>
                        <Stack tokens={{ childrenGap: 10, padding: "10px" }}>
                          <StackItem><Body1Strong>{`Score Assigned ${index + 1} `}</Body1Strong></StackItem>
                          <StackItem>From: {score.from}</StackItem>
                          <StackItem>To: {score.to}</StackItem>
                          <StackItem>Score: {score.sc}</StackItem>
                          <StackItem>Rank: {score.rank}</StackItem>
                        </Stack>
                      </StackItem>
                    </>
                  ));
                })
            )}
          </Stack>

        </>
          {/* <Button shape="circular" style={{display:"none"}} ref={buttonref} type="submit">Validate</Button> */}
        </form>,
    }

  };
  //overlay code ends here
  const DismissButton: React.FC<ButtonProps> = (props) => {
    return (
      <Button shape="circular"
        onClick={() => setSearchVal('')}
        {...props}
        appearance="transparent"
        icon={<Dismiss16Regular />}
        size="small"
      />
    );
  };


  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            <StackItem grow shrink>
              <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                <StackItem><Text></Text></StackItem>
                <StackItem grow shrink>
                  {/* <Breadcrumbs pageName="Devices" subPageName="Device Classification" subPageLink="/manage/devices/device_classification/" />  */}
                  <Breadcrumbs
                    items={[
                      { name: "Manage", link: "/home" },
                      { name: "Devices", link: "/manage/devices/overview" },
                      { name: "Device Classification", link: "/manage/devices/device_classification" },
                      { name: localStorage.getItem('classificationName'), link: "/manage/devices/device_classification/devices", isData: true },
                      { name: "Scores", link: "#" }
                    ]}
                  />
                </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            <Stack style={DynamicBoxingCSS} tokens={{ childrenGap: 10 }} horizontal>
              <StackItem style={DynamicBoxingCSS}>
                {/* pages code starts here */}
                <Stack style={DynamicBoxingCSS}>
                  <Stack tokens={{ childrenGap: 25 }} horizontal>
                    {/* <StackItem><Text></Text></StackItem> */}
                    <StackItem>
                      <FluentProvider theme={dashboardTheme}>
                        {/* <Title3> {localStorage.getItem('classificationName')} | Scores </Title3> */}
                      </FluentProvider>
                    </StackItem>
                  </Stack>
                  <FluentProvider style={parentHome} theme={dashboardTheme}>
                    <Stack style={parentHome} horizontal >
                      {/* SPACING BETWEEN INLINE AND PAGE */}
                      <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={menuItems} />
                      <StackItem style={DynamicBoxingCSS}>
                        <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                          <StackItem>
                            <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                            <Divider />
                          </StackItem>
                          <StackItem>
                            <StackItem style={wraperStyle}>
                              <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                  <StackItem>
                                  <SearchBar searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                                  </StackItem>
                                  <StackItem>
                                    <MenuDropdown open={filterMenuOpen} btn={
                                      <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                          {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                          <Body1> Filter </Body1>
                                        </Stack>
                                      </MenuButton>
                                    } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                      <Divider />
                                      <MenuList>
                                        <Stack tokens={{ childrenGap: 5 }}>
                                          <StackItem> <Text></Text> </StackItem>
                                          <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                          {/* <DropdownComponent optionData={columns}/> */}
                                          <DropdownComponent optionData={columns1} setDropDownValue={setDropDownValue1} dropDownvalue={dropDownValue1} />
                                          <StackItem> <Divider /> </StackItem>
                                          <StackItem> <Caption1> Value </Caption1> </StackItem>
                                          {/* <DropdownComponent optionData={columns}/> */}
                                          <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />
                                          <StackItem> <Divider /> </StackItem>
                                          <Stack tokens={{ childrenGap: 10 }} horizontal>
                                            <StackItem> <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false) }}> <Caption1> Apply </Caption1> </Button> </StackItem>
                                            <StackItem> <Button shape="circular" onClick={() => setFilterMenuOpen(false)}> <Caption1> Cancel </Caption1> </Button> </StackItem>
                                          </Stack>
                                        </Stack>
                                      </MenuList>
                                    </>} />
                                  </StackItem>
                                  <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                    <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> <FilterDismiss20Filled /> </StackItem>
                                        <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                      </Stack>
                                    </Button>
                                  </StackItem>
                                </Stack>
                                {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                              </Stack>
                              {filterArray.length > 0 && <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                                <Stack wrap horizontal >
                                  {filterArray.length > 0 && filterArray.map((item, index) => (
                                    <Button shape="circular" size="small">
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 1 }}>
                                            <StackItem><Text></Text></StackItem>
                                            <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </Button>
                                  ))}
                                </Stack>
                              </Stack>}
                            </StackItem>
                            <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                            <Stack horizontal enableScopedSelectors horizontalAlign="space-between" >
                              <StackItem> <Caption1> Showing {((currentPageNo - 1) * 10) + 1} to {(currentPageNo * 10) > totalRecords ? totalRecords : (currentPageNo * 10)} of {totalRecords} Records </Caption1> </StackItem>
                            </Stack>
                          </StackItem>

                          <Census_func data={final_data} setToastMessage={setToastMessage} setErrorToast={setErrorToast} func={set_final_data} searchVal={searchVal} pageNo={(currentPageNo - 1) * 10} setTotalPages={setTotalPages} setTotalRecords={setTotalRecords} isRefresh={isRefresh} setIsRefresh={setIsRefresh} setRefreshToast={setRefreshToast} exportBtnClicked={exportBtnClicked} setExportBtnClicked={setExportBtnClicked} />
                          <App_Monitored_Func
                            setAppData={setAppData}
                            searchVal={searchVal}
                            // pageNo={(currentPageNo - 1) * 50}
                            setTotalPages={setTotalPages}
                            setTotalRecords={setTotalRecords}
                            setOverlayOpen={setOverlayOpen}
                            setFormData={setFormDataBasic}
                            formdata={formDataBasic}
                            // setIsToast={setIsToast}
                            isRefresh={isRefresh}
                            setIsRefresh={setIsRefresh}
                            setRefreshToast={setRefreshToast}
                            deviceName={deviceName}
                            isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2}
                            filterArray={filterArray}
                          />
                          {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={columns} ></DataTable>) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                        </Stack>
                      </StackItem>
                    </Stack>
                  </FluentProvider>
                </Stack>
                <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={overLayData} isNavBtn={false} />
                {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
              </StackItem>
            </Stack>
          </StackItem>
          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>
    </>
  );
};